import React from 'react'
import { TreeChangesContent } from '../../components/details/researcher-trees/tabs/TreeChangesCard'
import { useTreeGroupDetailsContext } from '../providers/TreeGroupDetailsProvider'

export default function LatestChangesContent(): JSX.Element {
  const { group } = useTreeGroupDetailsContext()
  return <TreeChangesContent group={group} />
}
